import { css } from '@emotion/react';
import { useHover } from '@react-aria/interactions';
import { Children, FunctionComponent } from 'react';

import { colors } from '~src/theme/colors';

export const OpenModalButtonGroup: FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  const { hoverProps, isHovered } = useHover({});

  return Children.toArray(children).length > 1 ? (
    <div css={styles.wrapperStyle(isHovered)} {...hoverProps}>
      {children}
    </div>
  ) : (
    <>{children}</>
  );
};
const noBottomBorder = {
  borderBottom: '0px',
  borderBottomRightRadius: '0px',
  borderBottomLeftRadius: '0px',
};

const noTopBorder = {
  borderTop: '0px',
  borderTopRightRadius: '0px',
  borderTopLeftRadius: '0px',
};

const styles = {
  wrapperStyle: (hover?: boolean) =>
    css({
      button: {
        ...(hover ? { borderColor: colors.neutral75 } : {}),
      },
      'button:first-child': {
        ...noBottomBorder,
      },
      'button:not(:first-child):not(:last-child)': {
        ...noBottomBorder,
        ...noTopBorder,
      },
      'button:not(:last-child):before': {
        // throws without quotes
        content: '""',
        position: 'absolute',
        left: '16px',
        right: '16px',
        bottom: '0px',
        borderBottom: `1px solid ${colors.neutral91}`,
      },
      'button:last-child': {
        ...noTopBorder,
      },
    }),
};
